<template>
  <v-card max-width="100%" width="100%">
    <v-toolbar dense color="primary" dark>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{$t('stats.resume')}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-simple-table
        :fixed-header="true"
        :height="400"
        >
        <thead>
          <tr>
            <th class="text-center">{{$t('general.week')}}</th>
            <template v-if="$store.getters['company/data'].clients.length != 1">
              <th v-for="client in $store.getters['company/data'].clients" :key="client._id + 'request-headers'" class="text-center">{{$t('suppliersShipments.shipments') + ' ' + client.client.name}}</th>
            </template>
            <th class="text-center">{{$t('steps.clientOrder')}}</th>
            <th class="text-center">{{$t('steps.clientShipment')}}</th>
            <th class="text-center">{{$t('stats.remains')}}</th>
            <th v-for="supplier in $store.getters['company/data'].suppliers" :key="supplier._id + 'shipment-headers'" class="text-center">{{$t('suppliersShipments.shipments') + ' ' + supplier.supplier.name}}</th>
            <th v-if="$store.getters['company/data'].suppliers.length === 0" class="text-center">{{$store.getters['company/productionCompany'] ? $t('steps.productionShipments') : $t('steps.supplierShipments')}}</th>
            <th v-if="$store.getters['company/ddOn']" class="text-center">{{$store.getters['company/productionCompany'] ? $t('steps.inProgressProduction') : $t('stats.suppliersRemains')}}</th>
            <template v-if="$store.state.company.data.assemblyMode">
              <th v-for="supplier in $store.getters['company/data'].suppliers" :key="supplier._id + 'stock-headers'" class="text-center">{{$t('general.stockFrom')}} {{supplier.supplier.name}}</th>
            </template>
            <th class="text-center">{{$t('stats.stock')}}</th>
            <th class="text-center" v-for="supplier in $store.getters['company/data'].suppliers" :key="supplier._id + 'orders-headers'">{{$t('suppliersOrders.ordersTo') + ' ' + supplier.supplier.name}}</th>
            <th v-if="$store.getters['company/data'].suppliers.length === 0" class="text-center" >{{$store.getters['company/productionCompany'] ? $t('steps.productionBatch') : $t('steps.supplierOrders')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="n in maxLength" :key="n">
            <td class="text-center">{{ maxLength - n + 1 }}</td>
            <template v-if="$store.getters['company/data'].clients.length != 1">
              <td v-for="client in $store.getters['company/data'].clients" :key="client._id + 'shipment-values'" class="text-center">{{ client.requests[maxLength - n] != null ? client.requests[maxLength - n] : '' }}</td>
            </template>
            <td class="text-center">{{ clientOrder[maxLength - n] != null ? clientOrder[maxLength - n] : '' }}</td>
            <td class="text-center">{{ clientShipment[maxLength - n] != null ? clientShipment[maxLength - n] : '' }}</td>
            <td class="text-center">{{ remains[maxLength - n] != null ? remains[maxLength - n] : '' }}</td>
            <td v-for="supplier in $store.getters['company/data'].suppliers" :key="supplier._id + 'shipment-values'" class="text-center">{{ supplier.receipts[maxLength - n] != null ? supplier.receipts[maxLength - n] : '' }}</td>
            <td v-if="$store.getters['company/data'].suppliers.length === 0" class="text-center">{{ supplierShipments[maxLength - n] != null ? supplierShipments[maxLength - n] : '' }}</td>
            <td v-if="$store.getters['company/ddOn']" class="text-center">{{ supplierRemains[maxLength - n] != null ? supplierRemains[maxLength - n] : '' }}</td>
            <template v-if="$store.state.company.data.assemblyMode">
              <td v-for="supplier in $store.getters['company/data'].suppliers" :key="supplier._id + 'stock-values'" class="text-center">{{ supplier.stock[maxLength - n] != null ? supplier.stock[maxLength - n] : '' }}</td>
            </template>
            <td class="text-center">{{ stock[maxLength - n] != null ? stock[maxLength - n] : '' }}</td>
            <td class="text-center" v-for="supplier in $store.getters['company/data'].suppliers" :key="supplier._id + 'orders-values'">{{ supplier.orders[maxLength - n] != null ? supplier.orders[maxLength - n] : '' }}</td>
            <td v-if="$store.getters['company/data'].suppliers.length === 0" class="text-center">{{ supplierOrders[maxLength - n] != null ? supplierOrders[maxLength - n] : '' }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data : () => ({
    //
  }),
  computed: {
    clientOrder () {
      return this.$store.getters['company/data'].value.requests
    },
    clientShipment () {
      return this.$store.getters['company/data'].value.deliveries
    },
    remains () {
      return this.$store.getters['company/data'].value.remains
    },
    supplierShipments () {
      return this.$store.getters['company/data'].value.receipts
    },
    stock () {
      return this.$store.getters['company/data'].value.stock
    },
    supplierRemains () {
      return this.$store.getters['company/data'].value.suppliersRemains
    },
    supplierOrders () {
      return this.$store.getters['company/data'].value.orders
    },
    maxLength () {
      let max = 0
      if (this.$store.getters['company/data'].value.requests.length > max) {
        max = this.$store.getters['company/data'].value.requests.length
      } else if (this.$store.getters['company/data'].value.deliveries.length > max) {
        max = this.$store.getters['company/data'].value.deliveries.length
      } else if (this.$store.getters['company/data'].value.remains.length > max) {
        max = this.$store.getters['company/data'].value.remains.length
      } else if (this.$store.getters['company/data'].value.receipts.length > max) {
        max = this.$store.getters['company/data'].value.receipts.length
      } else if (this.$store.getters['company/data'].value.stock.length > max) {
        max = this.$store.getters['company/data'].value.stock.length
      } else if (this.$store.getters['company/data'].value.orders.length > max) {
        max = this.$store.getters['company/data'].value.orders.length
      }
      return max
    }
  }
}
</script>